import script from "./GupiaoAccessView.vue?vue&type=script&setup=true&lang=js"
export * from "./GupiaoAccessView.vue?vue&type=script&setup=true&lang=js"

import "./GupiaoAccessView.vue?vue&type=style&index=0&id=5b51caf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b51caf8"]])

export default __exports__